import axios from 'axios';

export const api = axios.create({
  responseType: 'json',
  timeout: 20000,
  withCredentials: true,
});
